import { analyticsReport } from "@dataseat-dsp-client/lib-reporter";

export type GranularityValueType = analyticsReport.GranularityValueType;
export const getGranularityFromSplits =
  analyticsReport.getGranularityFromSplits;
export const newGranularitySplit = analyticsReport.newGranularitySplit;
